import { useTranslations } from '@/i18n/translations';
import { Caption, TextLink } from '@leanin/ui';

/**
 * Republication attribution, shown on a Connect resource that carries a
 * leanin.org original. Pairs with the `rel=canonical` tag the server
 * renders for the same URL: search engines credit the leanin.org page,
 * readers get the link back to it. The URL is validated at the API boundary
 * as an absolute https leanin.org address, so it is parsed here without
 * ceremony.
 */
export function CanonicalAttribution({
  canonicalUrl,
}: {
  readonly canonicalUrl: string | null;
}) {
  const t = useTranslations('Resources');
  if (canonicalUrl === null) return null;
  const host = new URL(canonicalUrl).hostname;
  return (
    <Caption>
      {t.rich('detail.originallyPublished', {
        host,
        source: (chunks) => (
          <TextLink
            href={canonicalUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {chunks}
          </TextLink>
        ),
      })}
    </Caption>
  );
}
